import axios from 'axios'
import {useSiteUrl} from 'providers/EnvironmentProvider'
import {useCallback, useMemo} from 'react'
import {Exp1} from 'types'

const client = axios.create()

export const useExp1ProductsApiMethod = () => {
  const siteUrl = useSiteUrl()
  const hostname = useMemo(() => new URL(siteUrl).hostname, [siteUrl])

  return useCallback(
    async (productIds: string[]) => {
      if (productIds.length === 0) {
        return {tours: []}
      }

      // const {data} = await client.get<Exp1.Response>(`https://${hostname}/wp-json/exp1/v1/tours`, {
      //   params: {
      //     products: productIds.join(','),
      //   },
      // })

      // return data

      return {tours: []}
    },
    [hostname]
  )
}
